import {extent} from 'd3-array';
import moment from 'moment';

const _getExtents = (series) => {
  let extents = [];

  const _getSeriesExtents = (timeseries) => {
    return extent(timeseries.data, (datum) => {
      if (datum) {
        return moment(datum.date).isValid() ? datum.date : undefined;
      }
    });
  };
  series.forEach((datum) => {
    extents = extents.concat(_getSeriesExtents(datum));
  });

  return extent(extents);
};

export default (series, clampToFirstTimeDomain) => {
  if (!series || !series.length) {
    return [];
  }

  const extents = clampToFirstTimeDomain
    ? _getExtents([series[0]])
    : _getExtents(series);

  if (!extents[0] || !extents[1]) {
    return [];
  }

  return [extents[0], extents[1]];
};
